module.exports = __webpack_public_path__ + "img/step13_a_stand_power_connect_top_cross.16565c0b.png";